import { useAuth, useUser } from "@clerk/react"
import { useSessionQuery } from "../query/authenticated"
import { queryKeys } from "../query/keys"
import {
  type AccessDecision,
  getAuthConfig,
  getEffectiveAccessDecision,
} from "./config"
import { fetchRemoteAccessDecision } from "./remote"

const authConfig = getAuthConfig()

export function useRemoteAccessDecision(): {
  access: AccessDecision | null
  isChecking: boolean
} {
  const { isLoaded, userId } = useAuth()
  const { user } = useUser()
  const email = user?.primaryEmailAddress?.emailAddress ?? null
  const fallbackAccess = getEffectiveAccessDecision(
    email,
    authConfig,
    user?.publicMetadata,
  )
  const accessQuery = useSessionQuery<AccessDecision>({
    enabled: fallbackAccess !== "missing_email",
    queryFn: ({ sessionToken, signal }) =>
      fetchRemoteAccessDecision(sessionToken, signal),
    queryKey: queryKeys.auth.access(userId),
  })

  if (!isLoaded) {
    return { access: null, isChecking: false }
  }

  if (!userId || fallbackAccess === "missing_email") {
    return { access: fallbackAccess, isChecking: false }
  }

  return {
    access: accessQuery.data ?? (accessQuery.isError ? fallbackAccess : null),
    isChecking: accessQuery.isPending,
  }
}
